import { Text } from '@ydistri/ds';
import React, { PropsWithChildren } from 'react';

export const TextSmall: React.FC<PropsWithChildren> = ({ children }) => (
  <Text $size="small">{children}</Text>
);

export default TextSmall;
